<template>
  <div class="data" v-loading="loading">
    <div class="title">汇总数据</div>
    <div class="time">统计截止时间：{{loginobject.updatedAt ? $moment(loginobject.updatedAt*1000).format('YYYY-MM-DD') : 0 }}</div>
    <div class="img">
      <div class="imgone foo">
        <img :src="luse" class="img-flex">
        <div class="login-item">累计登录人数</div>
        <div class="num-item">{{ loginobject.loginUserTotalCount ? loginobject.loginUserTotalCount : 0 }}<span style="font-size: 14px">人</span></div>
        <img :src="luitem" class="img-item">
      </div>
      <div class="imgtwo foo">
        <img :src="zise" class="img-flex">
        <div class="login-item">累计登录次数</div>
        <div class="num-item">{{ loginobject.loginTotalCount ? loginobject.loginTotalCount : 0 }}<span style="font-size: 14px">次</span></div>
        <img :src="ziitem" class="img-item">
      </div>
      <div class="imgthere foo">
        <img :src="chense" class="img-flex">
        <div class="login-item">登录时长</div>
        <div class="num-item">{{ loginobject.loginTotalDuration ? loginobject.loginTotalDuration : 0 }}<span style="font-size: 14px">分钟</span></div>
        <img :src="chenitem" class="img-item">
      </div>
    </div>
    <div class="list">
      <div class="nav">
        <div class="nav-max">
          <div class="nav-left"></div>
          <div class="nav-center">明细数据</div>
        </div>
        <el-button type="primary" @click="exportHandle()">导出</el-button>
      </div>
      <template>
        <el-table
          :data="tableData"
          :header-cell-style="{background:'#EEF5FF',height:'60px',color:'#333333','text-align': 'center',}">
          style="width: 100%">
          <el-table-column label="序号" width="80" align="center">
            <template slot-scope="scope">
              {{ scope.$index + 1 }}
            </template>
          </el-table-column>
          <el-table-column
            prop="roleName"
            label="角色名"
            align="center"
            show-overflow-tooltip
            width="180">
          </el-table-column>
          <el-table-column
            prop="mobile"
            align="center"
            show-overflow-tooltip
            label="手机号码">
          </el-table-column>
          <el-table-column prop="lastLogin" align="center" show-overflow-tooltip label="最近登录时间">
            <template slot-scope="scope">
              {{scope.row.lastLogin?$moment(scope.row.lastLogin*1000).format('YYYY-MM-DD'):0}}
            </template>
          </el-table-column>
          <el-table-column
            prop="loginTimes"
            align="center"
            show-overflow-tooltip
            label="累计登录次数">
          </el-table-column>
          <el-table-column prop="lastLogoutTime" align="center" show-overflow-tooltip label="累计登录时长（分钟）">
            <template slot-scope="scope">
              {{scope.row.loginDurationMin?scope.row.loginDurationMin:0}}
            </template>
          </el-table-column>
        </el-table>
      </template>
      <div class="block">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage4"
          :page-size="10"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import luse from '../assets/luse.png'
import zise from '../assets/zise.png'
import chense from '../assets/chense.png'
import luitem from '../assets/luitem.png'
import ziitem from '../assets/ziitem.png'
import chenitem from '../assets/chenitem.png'
import top from '../assets/top.png'
import {getdatalist} from "../utils/data"
import api from '../utils/Url'
export default {
  data(){
    return{
      luse,
      zise,
      chense,
      luitem,
      ziitem,
      chenitem,
      top,
      tableData: [],
      queryParams:{
        pagesize:1,
        pageNumber:10
      },
      total:0,
      loading:false,
      currentPage4:1,
      loginobject:{
        loginUserTotalCount:null,
        loginTotalCount:null,
        loginTotalDuration:null,
        updatedAt:null,
      }
    }
  },
  created() {
    this.getlist()
  },
  methods: {
    getlist(){
      getdatalist(this.queryParams).then((obj) => {
        console.log(obj)
        this.loginobject.updatedAt = obj.summary.updatedAt //汇总数据
        this.loginobject.loginUserTotalCount = obj.summary.loginUserTotalCount //登录人数
        this.loginobject.loginTotalCount = obj.summary.loginTotalCount //登录次数
        this.loginobject.loginTotalDuration = obj.summary.loginTotalDuration //登录时长
        this.tableData = obj.usersList
        this.total = obj.totalRows
      }).catch(err => {
        console.log(err)
        if(err.code == 16){
          sessionStorage.removeItem('token');
          this.$router.push('/login')
        }
        this.$message.error(err)
      })
    },
    //导出
    exportHandle(){
      console.log("http://office.vsteach.com:8043/UsageDataSummaryExport?token="+sessionStorage.getItem('token'))
      window.location.href = "http://office.vsteach.com:8043/UsageDataSummaryExport?token="+sessionStorage.getItem('token')
    },
    handleSizeChange(val) {
      this.queryParams.pageNumber = val
      this.getlist()
    },
    handleCurrentChange(val) {
      this.queryParams.pagesize = val
      this.getlist()
    },
  },
}
</script>
<style lang='scss' scoped>
  .data{
    width:calc(100% - 450px);
    height: 100vh;
    padding: 20px 60px 0 60px;
    overflow: auto;
    .title{
      height: 59px;
      font-size: 42px;
      font-family: PingFang SC-Bold, PingFang SC;
      font-weight: 500;
      color: #333333;
      margin-left: 10px;
    }
    .time{
      height: 25px;
      font-size: 18px;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
      margin-left: 10px;
    }
    .img{
      display: flex;
      //justify-content: space-between;
      margin-top: 10px;
      //position: relative;
      min-width: 650px;
      flex-wrap:wrap;
      //overflow: auto;
      .imgone{
        width: 33%;
        height: 180px;
        flex-direction: column;
      }
      .imgtwo{
        width: 33%;
        height: 180px;
        flex-direction: column;
      }
      .imgthere{
        width: 33%;
        height: 180px;
        flex-direction: column;
      }
      .foo{
        position: relative;
        .login-item{
          position: absolute;
          left: 41px;
          top: 41px;
          color: #FFFFFF;
          font-weight: 500;
          font-size: 20px;
        }
        .num-item{
          position: absolute;
          left: 38px;
          top: 90px;
          font-size: 48px;
          font-family: Nirmala UI-Bold, Nirmala UI;
          font-weight: bold;
          color: #FFFFFF;
        }
        .ci-item{
          position: absolute;
          left: 156px;
          top: 132px;
          font-size: 14px;
          font-family: Nirmala UI-Regular, Nirmala UI;
          font-weight: 400;
          color: #FFFFFF;
        }
        .img-item{
          position: absolute;
          right: 6%;
          top: 40px;
          width: 100px;
          height: 100px;
        }
        .top{
          position: absolute;
          left: 190px;
          top: 127px;
          z-index: 2;
          width: 8px;
          height: 23px;
        }
      }
      .img-flex{
        width:100%;
        height: 180px;
      }
    }
    .list{
      min-width: 400px;
      //overflow: auto;
      background: #FFFFFF;
      box-shadow: 3px 6px 6px 1px rgba(192,205,241,0.3);
      border-radius: 19px 19px 19px 19px;
      opacity: 1;
      border: 1px solid rgba(235,235,235,0.5);
      margin-left: 5px;
      margin-bottom: 100px;
      padding: 32px 67px;
      .nav{
        height: 95px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .nav-max{
          display: flex;
          align-items: center;
          .nav-left{
            width: 6px;
            height: 30px;
            background: #578DE7;
            opacity: 1;
            margin-top: 6px;
            border-radius: 2px;
          }
          .nav-center{
            font-size: 32px;
            font-family: PingFang SC-Bold, PingFang SC;
            font-weight: 500;
            color: #333333;
            margin-left: 32px;
          }
        }
        .nav-export{
          width: 120px;
          height: 56px;
          background: #63ACFF;
          border-radius: 14px 14px 14px 14px;
          opacity: 1;
          font-size: 20px;
          font-family: PingFang SC-Bold, PingFang SC;
          font-weight: 500;
          color: #FFFFFF;
          display: flex;
          justify-content: center;
          align-items: center;
          text-align: center;
          cursor: pointer;
        }
      }
    }
    .block{
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 36px;
      min-width: 320px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/data.vue